import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { profile } from "../../data/profile";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            I’m <span className="purple">{profile.name}</span>, a{" "}
            <span className="purple">senior backend-focused full stack developer</span>{" "}
            with 9+ years of experience building and scaling production systems.
            <br />
            My focus is backend architecture, API design, performance optimization,
            and AWS delivery—building platforms that stay maintainable as traffic,
            features, and teams grow.
            <br />
            <br />
            What you get when I’m on a project:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Backend foundations: clear domain boundaries, scalable data models, versioned APIs
            </li>
            <li className="about-activity">
              <ImPointRight /> Performance discipline: profiling-led fixes, query/index tuning, payload optimization
            </li>
            <li className="about-activity">
              <ImPointRight /> Production readiness: AWS deployments (EC2/S3/RDS) and reliable CI/CD with GitHub Actions
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Build systems that scale cleanly—and stay easy to evolve."
          </p>
          <footer className="blockquote-footer">{profile.name}</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
